import axios from "axios";
import API_BASE from "../config/apiConfig";

// Configuration pour les appels publics (sans authentification)
const API_BASE_PUBLIC = `${API_BASE}/public/courses`;

/**
 * 🌍 Service pour les appels publics vers l'API des cours
 * Pas d'authentification requise - utilisé pour l'affichage public des cours
 */
const publicCourseService = {

    /**
     * 📚 Récupérer le résumé des cours (optimisé, public)
     */
    getCourseSummary: async () => {
        try {
            const response = await axios.get(`${API_BASE_PUBLIC}/summary`);
            console.log("📡 Résumé des cours récupéré (public):", response.data);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la récupération du résumé des cours (public) :", error);
            throw error;
        }
    },


//     getCourseSummary: async () => {
//     try {
//         const response = await axios.get(`${API_BASE_PUBLIC}/summary`, {
//             headers: {},            // ⛔ supprime le Bearer si un interceptor l’ajoute
//             withCredentials: false  // ⛔ n’envoie pas de cookies/session
//         });
//         console.log("📡 Résumé des cours récupéré (public):", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur lors de la récupération du résumé des cours (public) :", error);
//         throw error;
//     }
// },

    /**
     * 📚 Récupérer tous les cours (public)
     */
    getAllCourses: async () => {
        try {
            const response = await axios.get(`${API_BASE_PUBLIC}`);
            console.log("📡 Tous les cours récupérés (public):", response.data);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la récupération de tous les cours (public) :", error);
            throw error;
        }
    },

    /**
     * 📄 Récupérer les cours avec pagination (public)
     */
    getCoursesWithPagination: async (page = 0, size = 20) => {
        try {
            const response = await axios.get(`${API_BASE_PUBLIC}/paginated?page=${page}&size=${size}`);
            console.log(`📡 Cours paginés récupérés (public) - page ${page}:`, response.data);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la récupération des cours paginés (public) :", error);
            throw error;
        }
    },

    /**
     * 🏷️ Récupérer les cours par catégorie (public)
     */
    getCoursesByCategory: async (categoryId) => {
        try {
            const response = await axios.get(`${API_BASE_PUBLIC}/category/${categoryId}`);
            console.log(`📡 Cours de la catégorie ${categoryId} récupérés (public):`, response.data);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la récupération des cours par catégorie (public) :", error);
            throw error;
        }
    },

    /**
     * 🔍 Récupérer un cours par ID (public)
     */
    getCourseById: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_PUBLIC}/${id}`);
            console.log(`📡 Cours ${id} récupéré (public):`, response.data);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la récupération du cours (public) :", error);
            throw error;
        }
    },

    /**
     * 🏷️ Récupérer toutes les catégories (public)
     */
    getCategories: async () => {
        try {
            const response = await axios.get(`${API_BASE_PUBLIC}/categories`);
            console.log("📡 Catégories récupérées (public):", response.data);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la récupération des catégories (public) :", error);
            throw error;
        }
    },

    /**
     * 🔍 Rechercher des cours par titre (public)
     */
    searchCourses: async (query, page = 0, size = 20) => {
        try {
            const response = await axios.get(`${API_BASE_PUBLIC}/search?query=${encodeURIComponent(query)}&page=${page}&size=${size}`);
            console.log(`📡 Recherche "${query}" récupérée (public):`, response.data);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la recherche de cours (public) :", error);
            throw error;
        }
    },

    /**
     * 🖼️ Récupérer une image de cours via proxy (si nécessaire)
     */
    fetchCourseImage: async (imageUrl) => {
        try {
            const API_IMAGE_PROXY = `${API_BASE}/images/proxy`;
            const response = await fetch(`${API_IMAGE_PROXY}?url=${encodeURIComponent(imageUrl)}`);
            
            if (!response.ok) {
                throw new Error("Erreur lors de la récupération de l'image");
            }
            
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } catch (error) {
            console.error("❌ Erreur lors de la récupération de l'image :", error);
            return "/default-image.png"; // Image par défaut
        }
    }
};

export default publicCourseService;